export interface ISharedShiftSlot {
  sharedShiftStart: string;
  sharedShiftEnd: string;
  sharedShiftName: string;
  sharedFacilityId: string;
}

export const TIME_FORMAT = "h:mm a";
